// extracted by mini-css-extract-plugin
module.exports = {"my-event-root":"styles_my-event-root__3cxBX","no-data-content":"styles_no-data-content__2qEfp","group":"styles_group__3mV1Q","fab-btn":"styles_fab-btn__3vE7t"};